/* eslint-disable no-case-declarations */
import { Injectable, inject } from '@angular/core';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { exhaustMap, map, catchError, withLatestFrom, tap } from 'rxjs';
import { MyOrganizationService } from '../../services/my-organization/my-organization.service';
import {
  ManageTeamsDataGridService,
  ManageUsersDataGridService,
  ProjectSavingLogsDataGridService,
} from '@piqet-angular/features';
import * as sharedAction from '../shared/shared.actions';
import { of } from 'rxjs';
import * as MyOrganizationActions from './my-organization.actions';
import * as MyOrganizationSelector from './my-organization.selectors';
import { CustomModalService, DELETE_RECORD_LABEL } from '@piqet-angular/shared';
import { MyOrganizationFacade } from './my-organization.facade';
import { ProductGroupsDataGridService } from '@piqet-angular/features';
import { ProjectWorkflowDataGridService } from '@piqet-angular/features';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { OrganizationPreferencesDataGridService } from '@piqet-angular/features';
import { SsoGroupDataGridService } from '@piqet-angular/features';
import { ManageScenarioWorkflowDataGridService } from 'libs/features/src/lib/layout/my-organization/manage-scenario-workflow/manage-scenario-workflow-data-grid.service';
import { select, Store } from '@ngrx/store';
import { cloneDeep } from 'lodash';
import { Router } from '@angular/router';
import { UsersDetailDataGridService } from 'libs/features/src/lib/layout/my-organization/details/users-detail-data-grid.service';
import { TeamDetailsDataGridService } from 'libs/features/src/lib/layout/my-organization/details/team-details-data-grid.service';
import { PaymentTransactionDataGridService } from 'libs/features/src/lib/layout/my-organization/payment-transction/payment-transaction-data-grid.service';
import { SharedFacade } from '../shared/shared.facade';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
@Injectable()
export class MyOrganizationEffects {
  organizationMembershipId: any;
  adminOranizationMembershipId: any;
  private actions$ = inject(Actions);

  getManageTeamsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getManageTeamsList),
      exhaustMap(action => {
        if (
          action.pathName == 'AdminForManageTeams' ||
          action.teamsPayload.pathName == 'AdminForManageTeams'
        ) {
          return this.myOrganizationService
            .getTeamsListForAdmin(action.teamsPayload.manageTeamsPayload || action.teamsPayload)
            .pipe(
              map((data: any) => {
                return MyOrganizationActions.getManageTeamsListSuccess({
                  teamsPayload: data.data,
                });
              }),
              catchError((error: any) => of(MyOrganizationActions.getManageTeamsListFailure(error)))
            );
        } else {
          return this.myOrganizationService
            .getTeamsList(action.teamsPayload.manageTeamsPayload || action.teamsPayload)
            .pipe(
              map((data: any) => {
                return MyOrganizationActions.getManageTeamsListSuccess({
                  teamsPayload: data.data,
                });
              }),
              catchError((error: any) => of(MyOrganizationActions.getManageTeamsListFailure(error)))
            );
        }
      })
    )
  );

  getManageTeamsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getManageTeamsListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  openMyOrgDeleteModal$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(MyOrganizationActions.openMyOrgDeleteModal),
        exhaustMap((action: any) => {
          return this.alertConfirmation(action);
        })
      ),
    { dispatch: false }
  );

  deleteManageData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.deleteManageData),
      exhaustMap(action => {
        return this.myOrganizationService.deleteManageData(action.payload, action.managetype).pipe(
          map((data: any) => {
            data['pathName'] = action.valueName;
            return MyOrganizationActions.deleteManageDataSuccess({
              deleteManageDataMessage: data,
            });
          }),
          catchError((error: any) => of(MyOrganizationActions.deleteManageDataFailure(error)))
        );
      })
    )
  );

  deleteManageDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.deleteManageDataSuccess),
      exhaustMap(action => {
        let url = this.router.url;
        let urlSlash = url.lastIndexOf('/');
        let id = url.slice(urlSlash + 1);
        const toaster = action.deleteManageDataMessage.messageType
          ? sharedAction.ToasterError({
              description: action.deleteManageDataMessage.message,
            })
          : sharedAction.ToasterSuccess({
              description: action.deleteManageDataMessage.message,
            });
        switch (action.deleteManageDataMessage.pathName) {
          case 'manageProductGroups':
            const productGroupsPayload =
              this.productGroupsDataGridService.getProductGroupsPayload('');
            return of(
              MyOrganizationActions.getProductGroupsList({
                productGroupsPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          case 'manageProjectWorkflow':
            const projectWorkflowPayload =
              this.projectWorkflowDataGridService.getprojectWorkflowPayload('');
            return of(
              MyOrganizationActions.getProjectWorkflowList({
                projectWorkflowPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          case 'manageScenarioWorkflow':
            const manageScenarioWorkflowPayload =
              this.scenarioWorkflowDataGridService.getManageScenarioWorkFlowPayload('');
            return of(
              MyOrganizationActions.getManageScenarioWorkflowList({
                manageScenarioWorkflowPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          case 'projectSavingLogs':
            const projectSavingLogsPayload =
              this.projectSavingLogsDataGridService.getProjectSavingLogsPayload('');
            return of(
              MyOrganizationActions.getProjectSavingLogsList({
                projectSavingLogsPayload,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          case 'organizationPreferences':
            if (
              action.deleteManageDataMessage.message.toLowerCase() ==
              'organization packaging metrics deleted successfully'
            ) {
              return of(
                MyOrganizationActions.getPackagingMetricsData(),
                toaster,
                sharedAction.clearSearchFilter({ isClearSearch: true })
              );
            } else if (
              action.deleteManageDataMessage.message.toLowerCase() ==
              'organization indicators deleted successfully'
            ) {
              return of(
                MyOrganizationActions.getCustomCategoryList(),
                toaster,
                sharedAction.clearSearchFilter({ isClearSearch: true })
              );
            } else if (
              action.deleteManageDataMessage.message.toLowerCase() ==
              'organization year end month delete successfully.'
            ) {
              return of(
                MyOrganizationActions.getYearEndsOnData(),
                toaster,
                sharedAction.clearSearchFilter({ isClearSearch: true })
              );
            } else if (
              action.deleteManageDataMessage.message.toLowerCase() ==
              'my team deleted successfully.'
            ) {
              return of(
                MyOrganizationActions.getYearEndsOnData(),
                toaster,
                sharedAction.clearSearchFilter({ isClearSearch: true })
              );
            }
            break;
          case 'manageTeams/details/:id':
          case 'AdminForManageTeams/details/:id':
            const manageTeamPayload = this.teamDetailsDataGridService.getTeamDetailsPayload('');
            return of(
              MyOrganizationActions.getTeamGridData({
                manageTeamPayload,
                id,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          case 'manageUsers/details/:id':
          case 'AdminManageUsers/details/:id':
            const manageUserDetailsPayload =
              this.usersDetailDataGridService.getorganizationMembershipDetailsPayload('');
            return of(
              MyOrganizationActions.getManageUserDetailsList({
                manageUserDetailsPayload,
                id,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          case 'Organization Membership':
            const adminOrganizationMembershipPayload =
              this.usersDetailDataGridService.getAdminOrganizationDetailPayload('');
            return of(
              MyOrganizationActions.getAdminOrganizationMemberShipGridData({
                adminOrganizationMembershipPayload,
                id,
              }),
              toaster,
              sharedAction.clearSearchFilter({ isClearSearch: true })
            );
          default:
            return of(
              sharedAction.ToasterSuccess({
                description: 'data deleted successfully.',
              })
            );
        }
        return of(toaster);
      })
    )
  );

  getUsersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getUsersList),
      exhaustMap(action => {
        if (action.usersPayload.pathName == 'manageUsers' || action.pathName == 'manageUsers') {
          return this.myOrganizationService
            .getUsersList(action.usersPayload.manageUsersPayload || action.usersPayload)
            .pipe(
              map((data: any) => {
                return MyOrganizationActions.getUsersListSuccess({
                  usersList: data.data,
                });
              }),
              catchError((error: any) =>
                of(
                  MyOrganizationActions.getUsersListFailure(error),
                  sharedAction.hideShowLoader({ isLoaded: true })
                )
              )
            );
        } else {
          return this.myOrganizationService
            .getUsersListForAdmin(action.usersPayload.manageUsersPayload || action.usersPayload)
            .pipe(
              map((data: any) => {
                return MyOrganizationActions.getUsersListSuccess({
                  usersList: data.data,
                });
              }),
              catchError((error: any) => of(MyOrganizationActions.getUsersListFailure(error)))
            );
        }
      })
    )
  );

  getUsersListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getUsersListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  getProjectWorkflowList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getProjectWorkflowList),
      exhaustMap(action => {
        return this.myOrganizationService
          .getProjectWorkflowList(action.projectWorkflowPayload)
          .pipe(
            map((data: any) => {
              return MyOrganizationActions.getProjectWorkflowListSuccess({
                projectWorkflowList: data.data,
              });
            }),
            catchError((error: any) =>
              of(
                MyOrganizationActions.getProjectWorkflowListFailure(error),
                sharedAction.hideShowLoader({ isLoaded: true })
              )
            )
          );
      })
    )
  );

  getProjectWorkflowListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getProjectWorkflowListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  getManageScenarioWorkFlowListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getManageScenarioWorkflowSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  getProductGroupsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getProductGroupsList),
      exhaustMap(action => {
        return this.myOrganizationService.getProductGroupsList(action.productGroupsPayload).pipe(
          map((data: any) => {
            return MyOrganizationActions.getProductGroupsListSuccess({
              ProductGroupsList: data.data,
            });
          }),
          catchError((error: any) =>
            of(
              MyOrganizationActions.getProductGroupsListFailure(error),
              sharedAction.hideShowLoader({ isLoaded: true })
            )
          )
        );
      })
    )
  );

  getProductGroupsListSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getProductGroupsListSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  getLitterImpactData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getLitterImpactData),
      exhaustMap(() => {
        return this.myOrganizationService.getEditLitterImpactAsync().pipe(
          map((data: any) => {
            const litterImpactData = [];
            litterImpactData.push(data.data); // As gridData in Ag-grid requires array
            return MyOrganizationActions.getLitterImpactDataSuccess({
              litterImpactData: data.data,
            });
          }),
          catchError((error: any) => of(sharedAction.ToasterError({ description: error })))
        );
      })
    )
  );

  getSuppliersList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getSupplierList),
      exhaustMap(action => {
        return this.myOrganizationService.getSuppliersList(action.supplierListPayload).pipe(
          map((data: any) => {
            return MyOrganizationActions.getSupplierListSuccess({
              SupplierList: data.data,
            });
          }),
          catchError((error: any) =>
            of(
              MyOrganizationActions.getSupplierListFailure(error),
              sharedAction.hideShowLoader({ isLoaded: true })
            )
          )
        );
      })
    )
  );

  getCustomCategoryList$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getCustomCategoryList),
      exhaustMap(() => {
        return this.myOrganizationService.getCustomCategoryList().pipe(
          map((data: any) => {
            const customCategoryData = [];
            customCategoryData.push(data.data); // As gridData in Ag-grid requires array
            return MyOrganizationActions.getCustomCategoryListSuccess({
              customCategoryList: customCategoryData,
            });
          }),
          catchError((error: any) => of(sharedAction.ToasterError({ description: error })))
        );
      })
    )
  );

  getCustomSpeedosData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getCustomSpeedosData),
      exhaustMap(() => {
        return this.myOrganizationService.getCustomSpeedosData().pipe(
          map((data: any) => {
            const customSpeedosData = [];
            customSpeedosData.push(data.data); // As gridData in Ag-grid requires array
            return MyOrganizationActions.getCustomSpeedosDataSuccess({
              customSpeedosData: customSpeedosData,
            });
          }),
          catchError((error: any) => of(sharedAction.ToasterError({ description: error })))
        );
      })
    )
  );

  getPackagingMetricsData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getPackagingMetricsData),
      exhaustMap(() => {
        return this.myOrganizationService.getPackagingMetricsData().pipe(
          map((data: any) => {
            const packagingMetricsData = [];
            packagingMetricsData.push(data.data); // As gridData in Ag-grid requires array
            return MyOrganizationActions.getPackagingMetricsDataSuccess({
              packagingMetricsData: packagingMetricsData,
            });
          }),
          catchError((error: any) => of(sharedAction.ToasterError({ description: error })))
        );
      })
    )
  );

  getPackagingMetricsDataSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.getPackagingMetricsDataSuccess),
      exhaustMap(action => {
        return of(sharedAction.hideShowLoader({ isLoaded: true }));
      })
    )
  );

  resendConfirmationMail$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.resendConfirmationMail),
      exhaustMap(action => {
        return this.myOrganizationService
          .resendConfirmationMail(
            action.emailData.email,
            encodeURIComponent(
              environment.locationPath +
                `/#/activate-user?activationCode=${action.emailData.activationCode}`
            )
          )
          .pipe(
            map((data: any) => {
              return MyOrganizationActions.resendConfirmationMailSuccess({
                responseData: data,
              });
            }),
            catchError((error: any) =>
              of(
                MyOrganizationActions.getProductGroupsListFailure(error),
                sharedAction.hideShowLoader({ isLoaded: true })
              )
            )
          );
      })
    )
  );

  resendConfirmationMailSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.resendConfirmationMailSuccess),
      exhaustMap(action => {
        if (action.responseData.data) {
          return of(
            sharedAction.ToasterSuccess({
              description: action.responseData.message,
            })
          );
        }
        return of(
          sharedAction.ToasterError({
            description: action.responseData.message,
          })
        );
      })
    )
  );

  addUpdateOrganizationTeamMembership$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addUpdateOrganizationTeamMembership),
      exhaustMap(action => {
        return this.myOrganizationService
          .addUpdateOrganizationMembership(action.manageOrganizationTeamData.payload)
          .pipe(
            map((data: any) => {
              data['pathName'] = action.manageOrganizationTeamData.pathName;
              return MyOrganizationActions.addUpdateOrganizationTeamMembershipSuccess({
                manageOrganizationTeamData: data,
              });
            }),
            catchError((error: any) =>
              of(
                MyOrganizationActions.getManageUserDetailsListFailure(error),
                sharedAction.hideShowLoader({ isLoaded: true })
              )
            )
          );
        // }
      })
    )
  );

  addUpdateOrganizationTeamMembershipSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addUpdateOrganizationTeamMembershipSuccess),
      exhaustMap(action => {
        if (action.manageOrganizationTeamData.pathName == 'adminOrganization/details/:id') {
          const adminOrgMembershipGridDataPayload =
            this.usersDetailDataGridService.getAdminOrganizationDetailPayload('');
          const id = action.manageOrganizationTeamData.id;
          return of(
            sharedAction.ToasterSuccess({
              description: action.manageOrganizationTeamData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true }),
            MyOrganizationActions.getAdminOrganizationMemberShipGridData({
              adminOrganizationMembershipPayload: adminOrgMembershipGridDataPayload,
              id: id,
            })
          );
        } else {
          const orgMembershipGridDataPayload =
            this.usersDetailDataGridService.getorganizationMembershipDetailsPayload('');
          const url = this.router.url;
          const urlSlash = url.lastIndexOf('/');
          const id = url.slice(urlSlash + 1);
          return of(
            sharedAction.ToasterSuccess({
              description: action.manageOrganizationTeamData.message,
            }),
            sharedAction.clearSearchFilter({ isClearSearch: true }),
            MyOrganizationActions.getManageUserDetailsList({
              manageUserDetailsPayload: orgMembershipGridDataPayload,
              id: id,
            })
          );
        }
      })
    )
  );

  addEditSSOGroup$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addEditSSOGroup),
      exhaustMap(action => {
        return this.myOrganizationService.saveOrgSSOConfiguration(action.ssoGroupData).pipe(
          map((data: any) => {
            return MyOrganizationActions.addEditSSOGroupSuccess({
              ssoGroupData: data,
            });
          }),
          catchError((error: any) =>
            of(
              MyOrganizationActions.getProjectSavingLogsListFailure(error),
              sharedAction.hideShowLoader({ isLoaded: true })
            )
          )
        );
      })
    )
  );

  addEditManageProjectWorkFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addEditProjectWorkFlow),
      exhaustMap(action => {
        return this.myOrganizationService
          .addEditManageProjectWorkFlowData(action.manageProjectWorkFlowData)
          .pipe(
            map((data: any) => {
              return MyOrganizationActions.addEditProjectWorkFlowSuccess({
                manageProjectWorkFlowData: data,
              });
            }),
            catchError((error: any) =>
              of(MyOrganizationActions.getProjectWorkflowListFailure(error))
            )
          );
      })
    )
  );

  addEditManageProjectWorkFlowSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addEditProjectWorkFlowSuccess),
      exhaustMap(action => {
        if (action.manageProjectWorkFlowData.messageType != 0) {
          return of(
            MyOrganizationActions.getProductGroupsListFailure({
              error: action.manageProjectWorkFlowData.message,
            })
          );
        }
        this.modal.close();
        const manageProjectWorkFlowPayload =
          this.productGroupsDataGridService.getProductGroupsPayload('');
        return of(
          sharedAction.ToasterSuccess({
            description: action.manageProjectWorkFlowData.message,
          }),
          sharedAction.clearSearchFilter({ isClearSearch: true }),
          MyOrganizationActions.getProjectWorkflowList({
            projectWorkflowPayload: manageProjectWorkFlowPayload,
          })
        );
      })
    )
  );

  addEditManageScenarioWorkFlow$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addEditScenarioWorkFlow),
      exhaustMap(action => {
        return this.myOrganizationService
          .addEditManageScenarioWorkFlowData(action.manageScenarioWorkFlowData)
          .pipe(
            map((data: any) => {
              return MyOrganizationActions.addEditScenarioWorkFlowSuccess({
                manageScenarioWorkFlowData: data,
              });
            }),
            catchError((error: any) =>
              of(
                MyOrganizationActions.getManageScenarioWorkflowList(error),
                sharedAction.hideShowLoader({ isLoaded: true })
              )
            )
          );
      })
    )
  );

  addEditManageScenarioWorkFlowSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addEditScenarioWorkFlowSuccess),
      exhaustMap(action => {
        if (action.manageScenarioWorkFlowData.messageType != 0) {
          return of(
            MyOrganizationActions.getManageScenarioWorkflowFailure({
              error: action.manageScenarioWorkFlowData.message,
            })
          );
        }
        this.modal.close();
        const manageScenarioWorkFlowPayload =
          this.productGroupsDataGridService.getProductGroupsPayload('');
        return of(
          sharedAction.ToasterSuccess({
            description: action.manageScenarioWorkFlowData.message,
          }),
          sharedAction.clearSearchFilter({ isClearSearch: true }),
          MyOrganizationActions.getManageScenarioWorkflowList({
            manageScenarioWorkflowPayload: manageScenarioWorkFlowPayload,
          })
        );
      })
    )
  );

  myOrganizationManageUserForEdit$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.myOrganizationManageUserForEdit),
      exhaustMap(action => {
        return this.myOrganizationService
          .SaveMyOrganizationEditUserForEdit(action.myOrganizationManageUserData.payload)
          .pipe(
            map((data: any) => {
              data['pathName'] = action.myOrganizationManageUserData.pathName;
              return MyOrganizationActions.myOrganizationManageUserForEditSuccess({
                saveManageUserData: data,
              });
            }),
            catchError((error: any) =>
              of(MyOrganizationActions.myOrganizationManageUserForEditFailure(error))
            )
          );
      })
    )
  );

  openAddEditSupplierFlowModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.openAddEditSupplierModal),
      exhaustMap((action: any) => {
        return this.myOrganizationService.getSupplierData(action.supplierId).pipe(
          map(data => {
            if (!data.messageType) {
              this.modal.invoke('listOfSuppliers', {
                initialState: {
                  headerName: action.headerName,
                  supplierData: data.data,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveSupplierEvent.subscribe((saveSupplierData: any) => {
                return of(this.myOrganizationFacade.addEditSupplier(saveSupplierData));
              });
            }
            return MyOrganizationActions.openAddEditSupplierModalSuccess({
              supplierData: data,
            });
          })
        );
      })
    )
  );

  myOrganizationTeamMemberSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.myOrganizationManageUserSuccess),
      exhaustMap(action => {
        const toaster = action.saveManageUserData.messageType
          ? sharedAction.ToasterError({
              description: action.saveManageUserData.message,
            })
          : sharedAction.ToasterSuccess({
              description: action.saveManageUserData.message,
            });
        let manageUsersPayload;
        // this.manageUsersDataGridService.getManageUsersPayload('');
        return of(
          MyOrganizationActions.getUsersList({
            usersPayload: manageUsersPayload,
          })
        );
      })
    )
  );

  addEditSupplier$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.addEditSupplier),
      exhaustMap(action => {
        return this.myOrganizationService.addEditSupplierData(action.supplierData).pipe(
          map((data: any) => {
            return MyOrganizationActions.addEditSupplierSuccess({
              supplierData: data,
            });
          }),
          catchError((error: any) =>
            of(
              MyOrganizationActions.getSupplierList(error),
              sharedAction.hideShowLoader({ isLoaded: true })
            )
          )
        );
      })
    )
  );

  openEditCustomSpeedosModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.openEditCustomSpeedosModal),
      exhaustMap((action: any) => {
        return this.myOrganizationService.getCustomSpeedosFormData().pipe(
          map(data => {
            if (!data.messageType) {
              this.modal.invoke('editCustomSpeedos', {
                initialState: {
                  headerName: action.headerName,
                  customSpeedosData: data.data,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveCustomSpeedosEvent.subscribe(
                (saveCustomSpeedosData: any) => {
                  return of(this.myOrganizationFacade.editCustomSpeedo(saveCustomSpeedosData));
                }
              );
            }
            return MyOrganizationActions.openEditCustomSpeedosModalSuccess({
              customSpeedosData: data,
            });
          })
        );
      })
    )
  );

  editCustomSpeedos$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.editCustomSpeedos),
      exhaustMap(action => {
        return this.myOrganizationService.editCustomSpeedosData(action.customSpeedosData).pipe(
          map((data: any) => {
            return MyOrganizationActions.editCustomSpeedosSuccess({
              customSpeedosData: data,
            });
          }),
          catchError((error: any) =>
            of(
              MyOrganizationActions.getCustomSpeedosData(),
              sharedAction.hideShowLoader({ isLoaded: true })
            )
          )
        );
      })
    )
  );

  editCustomSpeedosSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.editCustomSpeedosSuccess),
      exhaustMap(action => {
        this.modal.close();
        return of(
          sharedAction.ToasterSuccess({
            description: action.customSpeedosData.item2,
          }),
          MyOrganizationActions.getCustomSpeedosData()
        );
      })
    )
  );

  openEditPackagingMetricModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.openEditPackagingMetricsModal),
      exhaustMap((action: any) => {
        return this.myOrganizationService.getPackagingMetricsFormData().pipe(
          map(data => {
            if (!data.messageType) {
              this.modal.invoke('editPackagingMetrics', {
                initialState: {
                  headerName: action.headerName,
                  packagingMetricsData: data.data,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.savePackagingMetricsEvent.subscribe(
                (savePackagingMetricData: any) => {
                  return of(this.myOrganizationFacade.editPackagingMetric(savePackagingMetricData));
                }
              );
            }
            return MyOrganizationActions.openEditPackagingMetricsModalSuccess({
              packagingMetricsData: data,
            });
          })
        );
      })
    )
  );

  editPackagingMetrics$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.editpackagingMetrics),
      exhaustMap(action => {
        return this.myOrganizationService
          .editPackagingMetricsData(action.packagingMetricsData)
          .pipe(
            map((data: any) => {
              return MyOrganizationActions.editpackagingMetricsSuccess({
                packagingMetricsData: data,
              });
            }),
            catchError((error: any) =>
              of(
                MyOrganizationActions.getPackagingMetricsData(),
                sharedAction.hideShowLoader({ isLoaded: true })
              )
            )
          );
      })
    )
  );

  editPackagingMetricsSuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.editpackagingMetricsSuccess),
      exhaustMap(action => {
        this.modal.close();
        return of(
          sharedAction.ToasterSuccess({
            description: action.packagingMetricsData.message,
          }),
          MyOrganizationActions.getPackagingMetricsData()
        );
      })
    )
  );

  openEditCustomCategoryModal$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.openEditCustomCategoryModal),
      exhaustMap((action: any) => {
        return this.myOrganizationService.getCustomCategoryFormData().pipe(
          map(data => {
            if (!data.messageType) {
              this.modal.invoke('editCustomCategory', {
                initialState: {
                  headerName: action.headerName,
                  customCategoryData: data.data,
                },
                class: 'modal-xl',
              });
              this.modal.ref?.content.saveCustomCategoryEvent.subscribe(
                (saveCustomCategoryData: any) => {
                  return of(this.myOrganizationFacade.editCustomCategory(saveCustomCategoryData));
                }
              );
            }
            return MyOrganizationActions.openEditCustomCategoryModalSuccess({
              customCategoryData: data,
            });
          })
        );
      })
    )
  );

  editCustomCategory$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.editCustomCategory),
      exhaustMap(action => {
        return this.myOrganizationService.editCustomCategoryData(action.customCategoryData).pipe(
          map((data: any) => {
            return MyOrganizationActions.editCustomCategorySuccess({
              customCategoryData: data,
            });
          }),
          catchError((error: any) =>
            of(
              MyOrganizationActions.getCustomCategoryList(),
              sharedAction.hideShowLoader({ isLoaded: true })
            )
          )
        );
      })
    )
  );

  editCustomCategorySuccess$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.editCustomCategorySuccess),
      exhaustMap(action => {
        this.modal.close();
        return of(
          sharedAction.ToasterSuccess({
            description: action.customCategoryData.message,
          }),
          MyOrganizationActions.getCustomCategoryList()
        );
      })
    )
  );

  async alertConfirmation(action: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.myOrganizationFacade.deleteManageData(action.id, action.managetype, action.valueName);
      }
    });
  }

  inlineEditForProject$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MyOrganizationActions.inlineDataEditForOrganizationPref),
      exhaustMap(action => {
        return this.myOrganizationService.editCustomWeightings(action.prefrencesData).pipe(
          map((data: any) => {
            data = { ...data };
            data['pathName'] = action.pathName;
            data.messageType
              ? this.toaster.error(data.message)
              : this.toaster.success(data.message);
            return MyOrganizationActions.inlineDataEditForOrganizationPrefSuccess({
              prefrencesData: action.prefrencesData.indicatorId,
              module: action.prefrencesData.defaultValue,
              field: action.field,
            });
          }),
          catchError((error: any) =>
            of(MyOrganizationActions.inlineDataEditForOrganizationPrefFailure(error))
          )
        );
      })
    )
  );

  constructor(
    private myOrganizationService: MyOrganizationService,
    private manageTeamsDataGridService: ManageTeamsDataGridService,
    private modal: CustomModalService,
    private router: Router,
    private myOrganizationFacade: MyOrganizationFacade,
    private manageUsersDataGridService: ManageUsersDataGridService,
    private productGroupsDataGridService: ProductGroupsDataGridService,
    private projectWorkflowDataGridService: ProjectWorkflowDataGridService,
    private projectSavingLogsDataGridService: ProjectSavingLogsDataGridService,
    private usersDetailDataGridService: UsersDetailDataGridService,
    private organizationPreferencesDataGridService: OrganizationPreferencesDataGridService,
    private ssoGroupDataGridService: SsoGroupDataGridService,
    private teamDetailsDataGridService: TeamDetailsDataGridService,
    private scenarioWorkflowDataGridService: ManageScenarioWorkflowDataGridService,
    private store: Store,
    private toaster: ToastrService,
    private paymentTransactionDataGridService: PaymentTransactionDataGridService,
    private spinnerService: NgxSpinnerService,
    private swalService: SwalService
  ) {}
}
